import { z } from 'zod';

export const contactUsSchema = z.object({
  name: z.string().min(1, { message: 'Campo requerido' }),
  email: z.email({ message: 'Email inválido' }),
  company: z.string().min(1, { message: 'Campo requerido' }),
  role: z.string().optional(),
  message: z.string().min(1, { message: 'Campo requerido' }),
});

export type ContactUsSchema = z.infer<typeof contactUsSchema>;
